import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {create} from "../../../app/setters/create.js";
import {useSelector} from "react-redux";

export const useDodajZdarzenieProcesuSprawozdanie = (setErrors, close) => {

    const queryClient = useQueryClient()
    const rola = useSelector((state) => state.user.role)

    return useMutation({
        mutationFn: (data) => {
            return create(`/oper/sprawozdanie/proces`, data)
        },
        // onError: () => {
        //     toast.error('Błąd podczas operacji')
        // },
        onSettled: async (data, error, variables) => {
            await queryClient.invalidateQueries({
                queryKey: [`lista_procesow_sprawozdanie`, rola, variables.rejestr_id],
            })
        },
        onSuccess: async ({message, status, errors}) => {
            if (typeof setErrors === 'function') {
                await setErrors(errors)
            }
            status === 'success' ? await toast.success(message) : await toast.error(message)
            status === 'success' && typeof close === 'function' && close()
        },
    })
}
